import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface LotEditState {
    IsLegal: boolean;
    BasePrice: string | number;
    Deposit: number,
    depositType: string,
    name: string
}

const initialState: LotEditState = {
    IsLegal: false,
    BasePrice: 0,
    Deposit: 0,
    depositType: "",
    name: ""
};

const LotsEditor = createSlice({
    name: "lotEdit",
    initialState,
    reducers: {
        updateLotEditData: (state, action) => {
            return { ...state, ...action.payload };
        }
    },
});

export const { updateLotEditData } = LotsEditor.actions;
export default LotsEditor.reducer;